import BigNumber from 'bignumber.js'

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80
})
export const getExchangeNFTsAddress = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeNFTs && sushi.contracts.exchangeNFTs.options.address
}
export const getExchangeNFTsContract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeNFTs
}
export const getExchangeNFTs2Address = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeNFTs2 && sushi.contracts.exchangeNFTs2.options.address
}
export const getExchangeNFTs2Contract = sushi => {
  return sushi && sushi.contracts && sushi.contracts.exchangeNFTs2
}

/**
 * 查询当前nft市场支持的支付币种
 * @param exchangeNFTsContract
 * @param nftAddress
 * @returns {Promise<*>}
 */
export const exchangeNFTsGetNftQuotes = async (exchangeNFTsContract, nftAddress) => {
  return exchangeNFTsContract.methods.getNftQuotes(nftAddress).call()
}

/**
 * 挂单
 * @param exchangeNFTsContract
 * @param nftAddress nft地址
 * @param tokenId
 * @param quoteAddress 支付币种地址
 * @param price 是quote的价格，需要做对应的精度处理，比如bake要乘于10的18次方
 * @param account
 * @returns {Promise<*>}
 */
export const exchangeNFTsReadyToSellToken = async (
  exchangeNFTsContract,
  nftAddress,
  tokenId,
  quoteAddress,
  price,
  account
) => {
  return exchangeNFTsContract.methods
    .readyToSellToken(nftAddress, tokenId, quoteAddress, price)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

/**
 * 挂单成功后更新价格， 挂单前要授权nft 给exchangeNFTs合约
 * @param exchangeNFTsContract
 * @param nftAddress
 * @param tokenId
 * @param quoteAddress
 * @param price
 * @param account
 * @returns {Promise<*>}
 */
export const exchangeNFTsSetCurrentPrice = async (
  exchangeNFTsContract,
  nftAddress,
  tokenId,
  quoteAddress,
  price,
  account
) => {
  return exchangeNFTsContract.methods
    .setCurrentPrice(nftAddress, tokenId, quoteAddress, price)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 取消挂单
export const exchangeNFTsCancelSellToken = async (exchangeNFTsContract, nftAddress, tokenId, account) => {
  return exchangeNFTsContract.methods
    .cancelSellToken(nftAddress, tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 获取挂单数量。
export const exchangeNFTsGetAskLength = async (exchangeNFTsContract, nftAddress, quoteAddress) => {
  return await exchangeNFTsContract.methods.getAskLength(nftAddress, quoteAddress).call()
}
// 获取所有挂单
export const exchangeNFTsGetAsks = async (exchangeNFTsContract, nftAddress, quoteAddress) => {
  return await exchangeNFTsContract.methods.getAsks(nftAddress, quoteAddress).call()
}
// 分页获取挂单
export const exchangeNFTsGetAsksByPage = async (exchangeNFTsContract, nftAddress, quoteAddress, page, size) => {
  return await exchangeNFTsContract.methods.getAsksByPage(nftAddress, quoteAddress, page, size).call()
}
// 获取某个用户的挂单
export const getAsksByUser = async (exchangeNFTsContract, nftAddress, quoteAddress, account) => {
  return await exchangeNFTsContract.methods.getUserAsks(nftAddress, quoteAddress, account).call()
}
// 获取某个用户的挂单 返回: { tokenId: BigNumber, price: BigNumber, quote: string }[]
export const getUserAsksByNFT = async (exchangeNFTsContract, nftAddress, account) => {
  const { quotes, lengths, asks } = await exchangeNFTsContract.methods.getUserAsksByNFT(nftAddress, account).call()
  const allAsks = []
  for (let i = 0, index = 0; i < lengths.length; i++) {
    const size = Number(lengths[i].toString())
    if (size > 0) {
      allAsks.push(
        ...asks.slice(index, index + size).map(({ tokenId, price }) => ({
          tokenId,
          price,
          quote: quotes[i]
        }))
      )
      index += size
    }
  }

  return allAsks
}

/**
 *  购买token， 购买前要用给 exchangeNFT 合约授权quote。
 * @param exchangeNFTsContract
 * @param nftAddress
 * @param tokenId
 * @param quoteAddress
 * @param price
 * @param account
 * @returns {Promise<*>}
 */
export const buyToken = async (exchangeNFTsContract, nftAddress, tokenId, quoteAddress, price, account) => {
  return exchangeNFTsContract.methods
    .buyToken(nftAddress, tokenId, quoteAddress, price)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 竞价NFT token，竞价前需要完成 bidNFT 一次性合约授权quote
export const bidToken = async (exchangeNFTsContract, nftAddress, tokenId, quoteAddress, price, account) => {
  return exchangeNFTsContract.methods
    .bidToken(nftAddress, tokenId, quoteAddress, price)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 更新NFT token竞标价格
export const updateBidPrice = async (exchangeNFTsContract, nftAddress, tokenId, quoteAddress, price, account) => {
  return exchangeNFTsContract.methods
    .updateBidPrice(nftAddress, tokenId, quoteAddress, price)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 取消竞价
export const cancelBidToken = async (exchangeNFTsContract, nftAddress, tokenId, quoteAddress, account) => {
  return exchangeNFTsContract.methods
    .cancelBidToken(nftAddress, quoteAddress, tokenId)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 将token卖给指定竞价者
export const sellTokenTo = async (exchangeNFTsContract, nftAddress, tokenId, quoteAddress, price, to, account) => {
  return exchangeNFTsContract.methods
    .sellTokenTo(nftAddress, tokenId, quoteAddress, price, to)
    .send({ from: account })
    .on('transactionHash', tx => {
      return tx.transactionHash
    })
}

// 获取指定token的竞价数量。
export const getBidsLength = async (bidsNFTContract, nftAddress, quoteAddress, tokenId) => {
  return await bidsNFTContract.methods.getBidsLength(nftAddress, quoteAddress, tokenId).call()
}

// 获取指定token的竞价列表
export const getBids = async (bidsNFTContract, nftAddress, quoteAddress, tokenId) => {
  return await bidsNFTContract.methods.getBids(nftAddress, quoteAddress, tokenId).call()
}

// 获取指定地址的竞价列表
export const getUserBids = async (bidsNFTContract, nftAddress, quoteAddress, account) => {
  return await bidsNFTContract.methods.getUserBids(nftAddress, quoteAddress, account).call()
}
// 获取指定地址的竞价列表 返回{ tokenId: BigNumber; price: BigNumber; quote: string }[]
export const getUserBidsByNFT = async (bidsNFTContract, nftAddress, account) => {
  const { quotes, lengths, bids } = await bidsNFTContract.methods.getUserBidsByNFT(nftAddress, account).call()
  const allBids = []
  for (let i = 0, index = 0; i < lengths.length; i++) {
    const size = Number(lengths[i].toString())
    if (size > 0) {
      allBids.push(
        ...bids.slice(index, index + size).map(({ tokenId, price }) => ({
          tokenId,
          price,
          quote: quotes[i]
        }))
      )
      index += size
    }
  }
  return allBids
}
